export const ECD2020_EVENT_CODE = 'ecd2020';
export const PERANIS2020_EVENT_CODE = 'peranis';
